import { format } from 'date-fns'

/**
 * Calculates the previous date and formats both dates for API query parameters
 * @param date - The end date
 * @returns Formatted string for API: "DateFrom=YYYYMMDD&DateTo=YYYYMMDD"
 */
export const calcPrevDateRange = (date: Date, daysPast?: number): string => {
  const prevDate = new Date(date)
  // skip weekends
  prevDate.setDate(prevDate.getDate() - (daysPast || 1))
  const isWeekend = prevDate.getDay() === 6
  if (isWeekend) {
    prevDate.setDate(prevDate.getDate() - 1)
  }
  const formattedDateFrom = format(prevDate, 'yyyyMMdd')
  const formattedDateTo = format(date, 'yyyyMMdd')
  return `DateFrom=${formattedDateFrom}&DateTo=${formattedDateTo}`
} 